class collectionFilter extends HTMLElement {
    constructor() {
        super();
        const form = this.querySelector('form');
        form.addEventListener('submit', function (event) {
            event.preventDefault();
            this.onSubmit(event);
        }.bind(this));
    }
    onSubmit(event){
        event.preventDefault();
        unconvertPriceFilter(Currency.currentCurrency);
        const formData = new FormData(event.target.closest('form'));
        const searchParams = new URLSearchParams(formData).toString();
        const url = this.getAttribute('data-url');
        const sectionId = 'main-collection-filter-results';
        this.updateContent(url,searchParams,sectionId,this)
    }
    updateContent(url,searchParams,section,form){
        fetch(url+`?${searchParams}` + `&section_id=${section}`).then(function (response) {
            return response.text();
        }).then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            let catalog = doc.querySelector('.page-layout_catalog');
            let productGrid = catalog.querySelector('.js-product-grid-wrapper');
            let filter_active = doc.querySelector('.filters .filters__top');
            let filter_list = doc.querySelector('.filters .filters__list');
            document.querySelector('.page-layout_catalog').querySelector('.js-product-grid-wrapper').innerHTML=productGrid.innerHTML;
            document.querySelector('.filters .filters__top').innerHTML=filter_active.innerHTML;
            document.querySelector('.filters .filters__list').innerHTML=filter_list.innerHTML;
            reloadRange()
            convertPriceFilter(Currency.shopCurrency, Currency.currentCurrency);
            translateFilter()
            Currency.convertAll(Currency.shopCurrency, Currency.currentCurrency);

            window.history.replaceState({ }, '', url+`?${searchParams}`);
        }).catch(function (err) {

            console.error('Something went wrong.', err);
        });
    }
}
customElements.define('collection-filter', collectionFilter);

class cleareCollectionFilter extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click',function (event){
            event.preventDefault();
            this.onSubmit(event);
        }.bind(this))
    }
    onSubmit(event) {
        const url = this.getAttribute('data-url');
        const sectionId = 'main-collection-filter-results';
        this.updateContent(url,sectionId)
        console.log(url+ `?section_id=${sectionId}`)
    }
    updateContent(url,section){
        fetch(url+`&section_id=${section}`).then(function (response) {
            return response.text();
        }).then(function (html) {
            console.log("test")
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            let catalog = doc.querySelector('.page-layout_catalog');
            let productGrid = catalog.querySelector('.js-product-grid-wrapper');
            let filter_active = doc.querySelector('.filters .filters__top');
            let filter_list = doc.querySelector('.filters .filters__list');
            let sort_by = doc.querySelector('.filters input[name="sort_by"]');
            let sort_by_value = sort_by.value.split('?');
            document.querySelector('.page-layout_catalog').querySelector('.js-product-grid-wrapper').innerHTML=productGrid.innerHTML;
            document.querySelector('.filters .filters__top').innerHTML=filter_active.innerHTML;
            document.querySelector('.filters .filters__list').innerHTML=filter_list.innerHTML;
            // $('.js-sort-by').val( sort_by_value[0]);
            // $('.js-sort-by').trigger('change');
            reloadRange()
            convertPriceFilter(Currency.shopCurrency, Currency.currentCurrency);
            translateFilter()
            Currency.convertAll(Currency.shopCurrency, Currency.currentCurrency);
            window.history.replaceState({ }, '', url);
        }).catch(function (err) {

            console.error('Something went wrong.', err);
        });
    }

}
customElements.define('clear-collection-filter', cleareCollectionFilter )

function reloadRange(){
        var $block = $('.filters');
        if (!$block.length) {
            return;
        }
        var $range = $block.find('.filters__range');
        var min = $range.attr('data-min');
        var max = $range.attr('data-max');
        var $priceMin = $block.find('.filters__price_min');
        var $priceMax = $block.find('.filters__price_max');
        var $filtersTop = $block.find('.filters__top');
        var $buttonResetAll = $block.find('.filters__top-button_all');

        $range.ionRangeSlider({
            type: 'double',
            min: min,
            max: max,
            from: min,
            to: max,
            onStart: function onStart(data) {
                $priceMin.prop('value', data.from);
                $priceMax.prop('value', data.to);
            },
            onChange: function onChange(data) {
                $priceMin.prop('value', data.from);
                $priceMax.prop('value', data.to);
            }
        });
        var instance = $range.data('ionRangeSlider');
        $priceMin.on('input', function () {
            var val = $(this).prop('value');
            instance.update({
                from: val
            });
        });
        $priceMax.on('input', function () {
            var val = $(this).prop('value');
            instance.update({
                to: val
            });
        });
        $buttonResetAll.on('click', function () {
            $filtersTop.removeClass('show');
            $block.find('input[type="checkbox"]').prop('checked', false);
            $priceMin.val(min);
            $priceMax.val(max);
            instance.update({
                from: min,
                to: max
            });
        });
}
function convertPriceFilter(oldCurrency,newCurrency){
    let filterWrapper = $('.js-price-filter');
    let filterRange = $('.filters__range');
    let inputMin = filterWrapper.find('.filters__price_min');
    let inputMax = filterWrapper.find('.filters__price_max');
    let minValue = inputMin.attr('min');
    let maxValue = inputMax.attr('max');
    let convertedMinValue = Math.round(Currency.convert(minValue,oldCurrency,newCurrency));
    let convertedMaxValue = Math.round(Currency.convert(maxValue,oldCurrency,newCurrency));
    if (!filterRange.length) {
        return;
    }
    let newFilterRange = $('<input class="filters__range" type="text" value="">')
    newFilterRange.attr('data-min',convertedMinValue);
    newFilterRange.attr('data-max',convertedMaxValue);
    filterRange.data("ionRangeSlider").destroy();
    filterRange.remove();
    filterWrapper.prepend(newFilterRange);
    inputMin.attr('max',convertedMaxValue);
    inputMax.attr('max',convertedMaxValue);
    reloadRange();
}

function unconvertPriceFilter(currency){
    let filterWrapper = $('.js-price-filter');
    let inputMin = filterWrapper.find('.filters__price_min');
    let inputMax = filterWrapper.find('.filters__price_max');
    let minValue = inputMin.val();
    let maxValue = inputMax.val();
    let convertedMinValue = Math.round(Currency.convert(minValue,currency,Currency.shopCurrency));
    let convertedMaxValue = Math.round(Currency.convert(maxValue,currency,Currency.shopCurrency));
    if (!filterWrapper.length) {
        return;
    }
    inputMin.val(convertedMinValue);
    inputMax.val(convertedMaxValue);
}
$(document).ready(function (){
    convertPriceFilter(Currency.shopCurrency, Currency.currentCurrency);
});